import styled, { css } from 'styled-components'
import { Media, mbSize } from '../../theme'

export const Wrapper = styled.div`
  display: none;
  ${Media.lessThan(Media.small)} {
    display: flex;
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 100;
  }
`

const commonButton = css`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${mbSize(32)};
  font-weight: 400;
  line-height: ${mbSize(38)};
  width: 50%;
  height: ${mbSize(80)};
  text-align: center;
`

export const RedButton = styled.a`
  ${commonButton};
  background: #fb6b4a;
  color: #fff;
`

export const WhiteButton = styled.a`
  ${commonButton};
  background: #fff;
  color: #fb6b4a;
`

export const Placeholder = styled.div`
  display: none;
  ${Media.lessThan(Media.small)} {
    display: block;
    width: 100%;
    height: ${mbSize(80)};
  }
`
